<template>
  <a-upload
    class="hmd-btn"
    name="file"
    :multiple="true"
    :show-upload-list="false"
    :before-upload="beforeUpload"
    :custom-request="customRequest"
    :disabled="disabled"
		:accept="accept"
  >
    <a-button v-if="!isTextButton" :disabled="disabled" :loading="uploading">
      {{ buttonText || "文件导入" }}
    </a-button>
    <p v-else class="hover-blue">{{ buttonText || "本地文件导入" }}</p>
  </a-upload>
</template>

<script lang="ts">
import { computed, defineComponent, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { FileUploadService } from "@/core";
import { FileRecord } from "@/core/services/file-upload.interface";
import { getFileExt } from "@/utils";

export default defineComponent({
  isGlobal: true,
  name: "SingleFileUpload",
  props: {
    value: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxSize: {
      type: Number,
      default: 100, // 100M
    },
    isTextButton: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: "",
    },
		accept:{
			type:String,
			default:""
		}
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    const state = reactive<{
      uploading: boolean;
      fileList: FileRecord[];
    }>({
      uploading: false,
      fileList: [],
    });

    const maxSizeByte = computed(() => {
      return props.maxSize * 1024 * 1024;
    });

    const beforeUpload = (file) => {
      if (file.size > maxSizeByte) {
        message.warning(`单个文件不得超过${props.maxSize}M`);
        return false;
      }
    };

    const customRequest = async ({ file }) => {
      state.uploading = true;
      const url = await FileUploadService.uploadToOss(file);
      const fileRecord = new FileRecord();
      fileRecord.merge({
        uid: file.uid,
        name: file.name,
        suffix: getFileExt(file.name),
        size: file.size,
        url,
      });
      emit("update:value", url);
      emit("change", url);
      state.uploading = false;
    };

    return {
      ...toRefs(state),
      beforeUpload,
      customRequest,
    };
  },
});
</script>
